import { render, staticRenderFns } from "./LoaderView.vue?vue&type=template&id=a729824c&"
import script from "./LoaderView.vue?vue&type=script&lang=js&"
export * from "./LoaderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports